import { supabase } from "./client";

/**
 * Gets a valid Supabase access token, refreshing if necessary.
 * Logs the token for debugging.
 * @returns {Promise<string | null>} The access token, or null if not available.
 */
export async function getValidAccessToken(): Promise<string | null> {
  // Try to get the current session
  let {
    data: { session },
  } = await supabase.auth.getSession();

  // If no session or token, try to refresh
  if (!session || !session.access_token) {
    const { data, error } = await supabase.auth.refreshSession();
    if (error) {
      console.error("Error refreshing session:", error);
      return null;
    }
    session = data.session;
  }

  // Token retrieved successfully

  return session?.access_token || null;
}
